<!--
  - 首页顶部banner
-->

<template>
  <div class="banner">
    <div id="canvas"/>
    <div class="main">
      <h1>ByteLang 字节社 & 软件开发交流</h1>
      <div class='subtitle'>
        <h3>我们希望营造一个具有技术分享、极客精神、富有探讨精神的社区</h3>
        <h3>我们希望给您提供一个在日常开发、学习过程中稳定、易用、快捷的工具</h3>
      </div>
    </div>
  </div>
</template>

<script>
  import canvas from './libs/canvas'

  export default {
    name: 'banner',
    data(){
      return {};
    },
    methods: {},
    mounted(){
      canvas.initialise();
    },
    created(){
    }
  }
</script>

<style scoped lang="less">
  @banner-height: 300px;

  .banner {
    overflow: hidden;
    height: @banner-height;
    display: flex;
    flex-direction: column;
    //canvas 样式
    #canvas {
      height: @banner-height;
      background-color: #313131;
      width: 100%;
      position: absolute;
      z-index: -1;
    }

    //主文字
    .main {
      color: #fff;
      display: flex;
      flex-direction: column;
      padding-left: 200px;
      padding-top: 50px;

      h1 {
        font-size: 35px;
      }

      .subtitle {
        h3:first-child {
          margin-top: 30px;
          padding: 10px 0;
        }
      }
    }
  }
</style>
